// extracted by mini-css-extract-plugin
export default {"scrollContainer":"Scroll_scrollContainer__1V+LV"};